var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email__Type=Email",
    className: "email__Type=Email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email__Vector",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 8.143a2.83 2.83 0 0 1 2.83-2.83h12.34A2.83 2.83 0 0 1 21 8.143v8.143a2.83 2.83 0 0 1-2.83 2.83H5.83A2.83 2.83 0 0 1 3 16.286V8.143Zm1.25-.5c-.05.158-.076.326-.076.5v8.143c0 .915.741 1.656 1.655 1.656h12.342c.914 0 1.655-.741 1.655-1.656V8.143c0-.176-.027-.345-.078-.504l-5.886 4.528a3.06 3.06 0 0 1-3.731 0L4.25 7.644Zm.728-.92 5.869 4.513a1.886 1.886 0 0 0 2.299 0l5.871-4.516a1.647 1.647 0 0 0-.846-.233H5.829c-.31 0-.602.086-.85.236Z",
    className: "email__Vector",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.b467afe58c8ac39a6646d8d5ecfdbbb3.svg";
export { ForwardRef as ReactComponent };